import React from 'react';
import './ledger-header.scss';
import {
  dispatch,
  getCustomerInvite,
  updateIsSideDrawerOpen,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { SVGS } from '@zonofi/zono-money-design-system';

export interface LedgerHeaderProps {
  openFiltersDrawer: (val: string) => void;
}
export const LedgerHeader: React.FC<LedgerHeaderProps> = ({
  openFiltersDrawer,
}) => {
  const inviteData = useAppSelector(getCustomerInvite);
  const openDrawer = () => {
    dispatch(updateIsSideDrawerOpen(true));
  };
  return (
    <div className="ledger-screen-header">
      <div className="ledger-screen-header-seller">
        <div
          className="ledger-screen-header-seller-logo-container"
          onClick={openDrawer}
        >
          {inviteData?.seller?.profileImg ? (
            <img
              src={inviteData?.seller?.profileImg}
              className="ledger-screen-header-seller-logo-container-img"
            />
          ) : (
            <img src={SVGS.UserProfileIcon} />
          )}
        </div>
        <div className="ledger-screen-header-seller-info">
          <span className="ledger-screen-header-seller-info-name font-primary-semibold">
            {inviteData?.seller?.name}
          </span>
          <span className="ledger-screen-header-seller-info-subtitle font-primary">
            Ledger
          </span>
        </div>
      </div>
      <div className="ledger-screen-header-right">
        <img
          src={SVGS.CalenderIconNew}
          alt=""
          onClick={() => {
            openFiltersDrawer('DateRange');
          }}
        />
      </div>
    </div>
  );
};
